import "./Faq.css";

const Faq = function (props) {
  
  let localIsOpen = props.show == " show " ? 'openItem' : 'closeItem';
  let showHtmlclassName=!localIsOpen ? "collapse " : "collapse show ";
  // console.log (props.show + " "+  props.isOpen+ " index: "+props.index);
  // console.log(localIsOpen+ " index: "+props.index);

    return (
        <div className={'accordion-item card '+localIsOpen}>
        <div className="title card-header" id={"accHead_" + props.wpId +"_"+ props.index} >
            <div className="btn btn-link collapsed" data-toggle="collapse" data-target={"#accColapse_" + props.wpId +"_"+ props.index} onClick={() => props.toggleInnerItem(props.index)} 
            aria-expanded="true" aria-controls="collapseOne" > 
            <div className="col-2 col-md-1 iconDiv">
              <i className="accIcon"></i>
             </div>
            <h4  className="col-10 col-md-11 mb-0"  dangerouslySetInnerHTML={{__html: props.data.Title}}>
              {/* {props.data.Title} */}
              </h4>
            </div>
        </div>

        <div id={"accColapse_" + props.wpId +"_"+ props.index} className={"row no-gutters accColapse_" + props.wpId+"_"+props.catId+" collapse "+ props.show} aria-labelledby={"accHead" + props.wpId +"_"+ props.index} 
            data-parent={"accordion_" + props.wpId }>
            <div className="col-2 col-md-1 right-card-body"></div>
            <div className="card-body col-10 col-md-11" dangerouslySetInnerHTML={{__html: props.data.MODFAQAnswer}}/>
        </div>
      </div>
    );
  // }
}
 

export default Faq;